interface ScrollToTopProps {
  smooth?: boolean;
}
export const scrollToTop = ({ smooth = false }: ScrollToTopProps = {}) => {
  const config: {
    behavior?: 'auto' | 'smooth';
    top: number;
    left: number;
  } = { top: 0, left: 0 };

  if (smooth) {
    config.behavior = 'smooth';
  }

  window.scrollTo(config);
};
